import { SearchQuery } from "shared/data/reducers/types/storage";
import { HotelOfferDetail, RoomCategory } from "shared/types/hotels";

const filterMealOptions = (searchQuery: SearchQuery) => (
  hotelOffer: HotelOfferDetail | RoomCategory
): boolean => {
  if (!searchQuery.mealOption || searchQuery.mealOption.length === 0) {
    return true;
  }

  let hotelMeals;
  if (
    "RoomCategoriesInfo" in hotelOffer &&
    hotelOffer.RoomCategoriesInfo?.MealsOptions?.Meals
  ) {
    hotelMeals = hotelOffer.RoomCategoriesInfo.MealsOptions.Meals;
  }
  if (hotelMeals) {
    return hotelMeals.some((meal) =>
      searchQuery.mealOption.includes(meal.Basis.Code)
    );
  }

  if ("Meals" in hotelOffer && hotelOffer.Meals?.Basis?.Code) {
    const roomMealCode = hotelOffer.Meals.Basis.Code;
    return searchQuery.mealOption.includes(roomMealCode);
  }

  return false;
};

export default filterMealOptions;
